import React from 'react';
import { useState } from 'react';
const TestEnvironment = () => {
  const [accessToken, setAccessToken] = useState("");
  const [afasLink, setAfasLink] = useState("");

  async function getMetaInfo(){
    var response = await fetch('/afas/getMetaInfo', {
      method: 'GET',
    }); 
    console.log(response);
    var responseData = await response.json();
    console.log(responseData);
  }
  async function fetchLink(){
    var response = await fetch('/afas/fetchLink', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        afasLink: afasLink,
      }),
    }); 
    console.log(response);
    var responseData = await response.json();
    console.log(responseData);
  }

  const handleChangeAccess = (e) => {
    setAccessToken(e.target.value);
  };
  const handleChangeAfasLink = (e) => {
    setAfasLink(e.target.value);
  };
  async function postFactviewAI(impid, case_id){
        const response = await fetch("http://localhost:3000/api/importmodule/execute", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-api-key": 'b1f4c3d7a82e1f6d9a7c4f59e3810b2a5d9d23cf1e87b4a6c53a72f0e5c9d48a'
        },
        body: JSON.stringify({ impid, case_id })
        });

        const data = await response.json();
        console.log(data);
    }
  return (
    <div className="">
      <div>
        <p>Access Token: </p>
        <input value={accessToken} onChange={handleChangeAccess} />
      </div>
      <div>
        <button className="import-btn hover" onClick={()=>{getMetaInfo();}}>Get MetaInfo</button> 
        <div>
          <p>Afas link: </p>
          <input value={afasLink} onChange={handleChangeAfasLink} />
        </div>
        <button className="import-btn hover" onClick={()=>{fetchLink();}}>Fetch Link</button> 
        <button className="import-btn hover" onClick={()=>{postFactviewAI(1, 3035);}}>FVAI Execute</button> 
     
      </div>
    </div>
  );
};

export default TestEnvironment;
